import SunEditor from "suneditor-react";
import axios from "axios";
import {websetting} from "../helpers/websetting";
import { UploadBeforeHandler } from "suneditor-react/dist/types/upload";

interface EditorProps {
    details: string;
    onChange: (content: string) => void;
}

function Editor({ details, onChange }: EditorProps) {
    const onImageUploadBefore = (files: File[], info: object, uploadHandler: UploadBeforeHandler): boolean | undefined => {
        files.forEach((f)=>{
            const formData = new FormData();
            formData.set("File",f);
            formData.set("NameHe","popUp");
            formData.set("NameAr","popUp");
            axios.post(
                websetting.cmsUrl + 'ConfigCmsFile/AddFile',
                formData,{
                    headers: {
                        'Accept-Language':localStorage.getItem("lang") as string,
                        'content-type': 'multipart/form-data',
                        'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
                    }
                }
            ).then(({data}) => {
                const imageUrl = data?.fileUrl.startsWith('http') ? data?.fileUrl : websetting.cmsUrl + data?.fileUrl;
                uploadHandler({
                    result: [{
                        url: imageUrl,
                        name: f.name,
                        size: f.size
                    }]
                });
            });
        })

        return false;
    }

    return (
        <>
            <SunEditor
                onImageUploadBefore={onImageUploadBefore}
                defaultValue={details}
                onChange={onChange}
                height={"350px"}
                setOptions={editoroptions}
            />
        </>
    )
}
export default Editor

export const editoroptions = {
    imageMultipleFile:true,
    imageAccept:".jpg,.jpeg,.png",
    buttonList: [
        ["undo", "redo"],
        ["bold", "underline", "italic", "strike","align","list"],
        ["fontSize", "formatBlock", "paragraphStyle", "blockquote"],
        ["subscript", "superscript"],
        ["fontColor", "hiliteColor",], "textStyle", "removeFormat",
        ["outdent", "indent"],
        ["horizontalRule", "lineHeight"],
        ["table", "link", "image", "video", "imageGallery"],
        ["codeView"]
    ]
}
